import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { FormGroupState } from 'ngrx-forms';
import { Observable } from 'rxjs/index';
import {
    SystemSettingsFormState,
    SystemSettingsFormValue
} from './admin-system-settings.state';

// TODO: Refactor the form to NOT use ngrx-form but for now keep it as an example if we need to use ngrx-forms for other things

const formStateSelector = (state: SystemSettingsFormState) => state.systemSettingsForm.formState;
const formStateValueSelector = (state: SystemSettingsFormState) => {
    if (state.systemSettingsForm.formState === undefined) {
        console.log('formStateValueSelector called too early');

        return undefined;
    }

    return state.systemSettingsForm.formState.value;
};

const loadingSelector = (state: SystemSettingsFormState) => state.systemSettingsForm.loading;

const isFormDirtySelector = (state: SystemSettingsFormState) => state.systemSettingsForm.formState.isDirty;

@Injectable()
export class AdminSystemSettingsSelectors {
    constructor(private store: Store<any>) {
    }

    selectFormState(): Observable<FormGroupState<SystemSettingsFormValue>> {
        return this.store.pipe(select(formStateSelector));
    }

    selectFormStateValue(): Observable<SystemSettingsFormValue> {
        return this.store.pipe(select(formStateValueSelector));
    }

    selectLoadingStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingSelector));
    }

    selectIsFormDirty(): Observable<boolean> {
        return this.store.pipe(select(isFormDirtySelector));
    }
}
